import { useMutation, useQueryClient } from "@tanstack/react-query"
import { makeCreateDocType } from "../../domain/use-cases/create-doc-type"
import { httpDocTypeRepository } from "../../data/repositories/doc-type-repository"

const createDocType = makeCreateDocType(httpDocTypeRepository)

export const useCreateDocType = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: createDocType,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["docTypes"] }),
  })
}
